module.exports = __webpack_public_path__ + "img/40ac62e.svg";